module.exports = __webpack_public_path__ + "static/media/parts.5.ed19dc58.png";